export enum DeviceTypes {
	Mobile = 1,
	Tablet = 2,
	Desktop = 3
}